const useHasPermissions = (
  userPermissions,
  requiredPermission,
  dynamicParams = {}
) => {
  // Bypass permissions check if no rules have been passed for requiring permissions
  if (!requiredPermission) {
    return true;
  }

  // If permission is requires (checkRules) then immediately return false for missing the user role's permissions
  if (!userPermissions) {
    return false;
  }

  // Iterate over user role's permissions to find at least one permission
  return userPermissions.some((permission) => {
    try {
      // If the permission requires a dynamic check, it will be an object
      // Example:
      // {
      //   name: "organization:read",
      //   rule: ({ activeMembershipId, orgIdParam }) => {
      //     return activeMembershipId === orgIdParam;
      //   },
      // },
      if (typeof permission === "object") {
        // First check if the name of permission is in fact the requiredPermission to check
        if (permission.name === requiredPermission) {
          return permission.rule(dynamicParams);
        }
        return false;
      }

      return requiredPermission === permission;
    } catch (error) {
      console.error("There was an issue checking user permissions.", {
        userPermissions,
        requiredPermission,
        dynamicParams,
      });
      return false;
    }
  });
};

export default useHasPermissions;
